import React from 'react';
import { ClockIcon } from '@heroicons/react/solid';

interface RentalType {
  id: number;
  priceCents: number;
  completedAt: string;
  rentalDays: Number;
}

interface props {
  history: RentalType[];
  botName: string;
}

export default function RentalHistory({ history, botName }: props) {
  return (
    <div
      className="overflow-auto"
      style={{ maxHeight: '275px', overflowY: 'scroll' }}
    >
      <ul className="flex flex-col space-y-1 overflow-auto">
        {[...history]
          .sort((a, b) => b.id - a.id)
          .map((tx: RentalType, index: number) => (
            <li
              key={index}
              className="flex bg-gray-100 items-center justify-between px-4 py-4 rounded-md"
            >
              <div className="flex items-center">
                <ClockIcon className="mr-1 h-5 w-5 text-gray-400" />
                <span className="text-sm font-normal text-gray-500">
                  {tx?.completedAt}
                </span>
              </div>
              <span className="text-sm font-normal text-gray-600">{`${botName} was rented for ${
                tx?.rentalDays
              } ${tx.rentalDays > 1 ? 'days' : 'day'} for $${
                tx.priceCents / 100
              }`}</span>
            </li>
          ))}
      </ul>
    </div>
  );
}
